import HelpViewArticle from '../../components/Help/HelpViewArticle';
import PageMain from '../../components/Navigation/PageMain/PageMain';

export default function HelpArticlePage() {
    return (
        <PageMain pageTitle="Article" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <HelpViewArticle />
                </div>
            </div>
        </PageMain>
    );
}
